import { render, staticRenderFns } from "./DepartmentCard.vue?vue&type=template&id=362ddbf4&scoped=true"
import script from "./DepartmentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DepartmentCard.vue?vue&type=style&index=0&id=362ddbf4&prod&scoped=true&lang=css"
import style1 from "./DepartmentCard.vue?vue&type=style&index=1&id=362ddbf4&prod&lang=css"
import style2 from "./DepartmentCard.vue?vue&type=style&index=2&id=362ddbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362ddbf4",
  null
  
)

export default component.exports